export default "__VITE_ASSET__2609cf74__"